var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"textCenter"},[_c('div',{ref:"textDiv",staticStyle:{"display":"none"}},[_vm._v("您已登录图书馆系统，请在新打开页面查看")]),_vm._v(" "),_c('a',{ref:"loginA",attrs:{"href":_vm.loginUrl,"target":"_blank","referrerpolicy":"no-referrer"}},[_vm._v(_vm._s(_vm.loginText))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c404fe70","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/library.vue
// module id = null
// module chunks = 